<template>
  <v-list dense class="drawer-days">
    <v-list-group
      v-for="day in allDays"
      :key="day.dayOfWeek"
      :value="day.dayOfWeek === currentRoute.day"
      no-action
      :class="$vuetify.breakpoint.smAndDown ? 'drawer-days-parent-mobile' : 'drawer-days-parent'"
      :disabled="loading"
      @click="onDayClick(day)"
    >
      <v-list-tile slot="activator">
        <v-list-tile-action>
          <v-icon color="green">{{ getCheckedIcon(day) }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <span :style="{'text-transform': 'capitalize', 'text-decoration': !isDayAccessible(day) ? 'line-through' : ''}">{{ $t(`mainComponent.${day.dayOfWeek}`) }}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <drawer-list-item
        v-for="(provider, index) in day.providers"
        :key="index"
        :item="mapProviderToItem(provider)"
        shift-right
        :active="isDayActive(day, provider)"
        @onNavigate="onProviderClick(day, provider)"
      />
    </v-list-group>
    <v-list-tile v-if="loading">
      <v-list-tile-content>
        <v-progress-circular style="margin: auto;" indeterminate color="primary" :width="3" />
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import TimeService from '@/services/TimeService';
import { mapActions, mapGetters } from 'vuex';
import DrawerListItem from './DrawerListItem.vue';

export default {
  name: 'DrawerDays',
  components: {
    'drawer-list-item': DrawerListItem,
  },
  props: {
    days: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  computed: {
    ...mapGetters('drawerStore', ['currentRoute']),
    daysOfWeek() {
      return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
    },
    allDays() {
      const result = this
        .daysOfWeek
        .map(day => this.days.find(d => d.dayOfWeek === day && d.providers.length > 0))
        .filter(r => r);

      return result;
    },
  },
  watch: {
    days(newDays) {
      if (!this.currentRoute.provider && this.currentRoute.isDishesOverview) {
        const day = newDays.find(d => d.dayOfWeek === this.currentRoute.day);
        if (!day) {
          this.navigate({
            path: `/dishes/${this.currentRoute.day}`,
            day: this.currentRoute.day,
            provider: null,
          });
        } else {
          const currentProvider = day.providers.find(p => p.name === this.$route.params.provider);
          let providerName = null;
          if (currentProvider) {
            providerName = currentProvider.name;
          } else if (day.providers.length > 0) {
            providerName = day.providers[0].name;
          }
          this.navigate({
            path: `/dishes/${this.currentRoute.day}/${providerName || ''}`,
            day: this.currentRoute.day,
            provider: providerName,
          });
        }
      }
    },
  },
  methods: {
    ...mapActions('drawerStore', ['navigate', 'updateProviders', 'toggleDrawer']),
    ...mapActions('userInfoStore', ['refetchUserBalance']),
    mapProviderToItem(provider) {
      return {
        text: provider.name,
        icon: 'color_lens',
        iconColor: provider.color,
      };
    },
    isDayAccessible(day) {
      const isBefore = TimeService.IsDateInPast(day.orderUntil);
      if (isBefore === null) {
        return false;
      }

      return (!isBefore) && day.providers.length > 0;
    },
    isDayActive(day, provider) {
      return `/dishes/${day.dayOfWeek}/${provider.name}` === this.currentRoute.path;
    },
    getCheckedIcon(day) {
      return day.userHasOrder ? 'check' : '';
    },
    onDayClick(day) {
      this.refetchUserBalance();
      let path = `/dishes/${day.dayOfWeek}`;
      let provider = null;
      if (day.providers[0]) {
        provider = day.providers[0].name;
        path = `${path}/${provider}`;
      }

      this.navigate({
        path,
        day: day.dayOfWeek,
        provider,
      });

      this.updateProviders(day.providers.map(p => ({
        path: `/dishes/${day.dayOfWeek}/${p.name}`,
        day: day.dayOfWeek,
        provider: p.name,
      })));
    },
    onProviderClick(day, provider) {
      this.refetchUserBalance();
      this.navigate({
        path: `/dishes/${day.dayOfWeek}/${provider.name}`,
        day: day.dayOfWeek,
        provider: provider.name,
      });

      if (this.$vuetify.breakpoint.smAndDown) {
        this.toggleDrawer();
      }
    },
  },
};
</script>

<style scoped>
  /* Used drawer items parent item hovering removing */
  .drawer-days >>> .v-list__group--active:after {
    background: rgba(0,0,0,0) !important;
  }

  .drawer-days >>> .v-list__group--active:before {
    background: rgba(0,0,0,0) !important;
  }
</style>
